// Module
var code = `<div class="page-item--faq">
  <h2 class="faq-title">{{title}}</h2>
  <dl class="faq-list">
    {{#items}}
    <div class="faq-item">
      <dt class="faq-q">{{q}}</dt>
      <dd class="faq-a">{{a}}</dd>
    </div>
    {{/items}}
  </dl>
</div>
`;
// Exports
module.exports = code;